module.exports = {
    webName:"海南华祥龙康养有限公司",
    webNm:"华祥龙",
    webTel:"19045019391",
    webNo:"琼ICP备2025063682号",
    webAddress:"海南省海口市龙华区大同街道海秀中路51-1号星城大厦第18层F411号",
    goods:[
        // {'value':51,'name':'学生文具供应'},
        // {'value':67,'name':'办公文具供应'},
        {'value':66,'name':'文教文化供应'},
        {'value':62,'name':'财会用品供应'},
        {'value':64,'name':'文件管理供应'},
        {'value':65,'name':'本册便签供应'},
        {'value':61,'name':'学生文具供应'},
        // {'value':67,'name':'文教文化供应'},
        // {'value':66,'name':'画具画材供应'},
        // {'value':67,'name':'笔袋文具盒供应'},
        // {'value':68,'name':'标签贴纸供应'},
    ],
    webColor:'#d4eff8',//蓝色#d4eff8,绿色#d4f8ec,黄色#ecf7dc,粉色#f8e8f9,红色#f9eae8
    webBg:'',
  }
